import React from "react"
import {StyledList} from "./style"

const List = ({children}) => (
    <StyledList>
        {children}
    </StyledList>
)

export default List